import { RoleWithMemberCountResponse } from '../types/response/role-with-member-count-response';
import { Role } from '../types/role';

/**
 * Maps API response DTO to domain model
 */
export const mapRoleFromDTO = (dto: RoleWithMemberCountResponse): Role => ({
  id: dto.id,
  name: dto.name,
  memberCount: dto.memberCount,
});

/**
 * Maps array of API response DTOs to domain models
 */
export const mapRolesFromDTO = (dtos: RoleWithMemberCountResponse[]): Role[] =>
  dtos.map(mapRoleFromDTO);
